// src/api.ts — thin fetch wrapper. On a native 401 it redirects to the Entra
// login (the SPA loads anonymously and drives its own auth flow — recipe §7).
// NO responseOverrides.401 in staticwebapp.config.json; this handles it.

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

const PUBLIC_PATHS = ["/login"];

function redirectToLogin(): void {
  if (PUBLIC_PATHS.includes(window.location.pathname)) return;
  const returnTo = window.location.pathname + window.location.search;
  window.location.replace(`/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(returnTo)}`);
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  if (res.status === 401) {
    redirectToLogin();
    throw new ApiError(401, "Not authenticated");
  }
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      if (body && typeof body.error === "string") msg = body.error;
    } catch { /* non-JSON error body — keep the generic message */ }
    throw new ApiError(res.status, msg);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
